import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Button } from '../ui/button.tsx';

export default function SignupSuccessDialog({ userData, onDashboard, onVerifyEmail }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-8 max-w-md w-full mx-4 space-y-6">
        <div className="text-center">
          <div className="flex justify-center">
            <CheckCircle className="h-12 w-12 text-green-500" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mt-4">Registration Successful!</h2>
          <p className="text-gray-500 mt-2">
            Welcome {userData.name}! Your account has been created successfully.
          </p>
        </div>

        <div className="bg-gray-50 rounded-lg p-4">
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-gray-500">Organization:</span>
              <span className="text-gray-900 font-medium">{userData.organizationName}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">Email:</span>
              <span className="text-gray-900 font-medium">{userData.email}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">Role:</span>
              <span className="text-gray-900 font-medium">{userData.roleName}</span>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <Button
            onClick={onDashboard}
            className="w-full bg-purple-600 hover:bg-purple-700 text-white"
          >
            Go to Dashboard
          </Button>
          <Button
            onClick={onVerifyEmail}
            variant="outline"
            className="w-full border-purple-600 text-purple-600 hover:bg-purple-50"
          >
            Verify Email
          </Button>
        </div>
      </div>
    </div>
  );
} 